import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteAbTestGroupUser = async (id: number) => {
  const response = await mutationExecute({
    variables: {
      id,
    },
    mutation: graphql(`
      mutation DeleteAbTestGroupUser($id: Float!) {
        deleteAbTestGroupUser(id: $id)
      }
    `),
  });

  return response.data?.deleteAbTestGroupUser ?? false;
};
